import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-prohibited-items';

export default function Example() {
  return (
    <>
      <Head>
        <title>What NOT to sell on Poshmark - Poshmark's Prohibited Items</title>
        <meta
          name='description'
          content="Prohibited items can get a seller's account suspended – or even deleted. Find out which ones belong to the no-go zone!"
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-prohibited-items' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-prohibited-items' />
        <meta property='og:title' content="What NOT to sell on Poshmark - Poshmark's Prohibited Items" />
        <meta
          property='og:description'
          content="Prohibited items can get a seller's account suspended – or even deleted. Find out which ones belong to the no-go zone!"
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-10-19T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-10-19T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
